import React, { useState, useEffect, useRef } from "react";

const CounterCard = ({ value, suffix = "", title }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);
  const isNumeric = typeof value === "number";

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.unobserve(cardRef.current);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isNumeric && isVisible) {
      let start = 0;
      const end = parseInt(value);
      const duration = 1500; // Animation duration in ms
      const step = Math.max(1, Math.floor(end / (duration / 50))); // Update every 50ms

      const timer = setInterval(() => {
        start += step;
        if (start > end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 50);

      return () => clearInterval(timer);
    }
  }, [value, isNumeric, isVisible]);

  return (
    <div
      ref={cardRef}
      className="p-6 text-center transform transition-all duration-700"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(30px)",
      }}
    >
      <div className="font-bodyFont font-bold text-accentBlue text-[42px] md:text-[48px] lg:text-[52px] mb-3">
        {isNumeric ? count : value}
        {suffix}
      </div>
      <div className="font-bodyFont font-normal text-grayText text-[14px] md:text-[15px] lg:text-[16px]">
        {title}
      </div>
    </div>
  );
};

export default CounterCard;
